import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Keyboard from '@/components/Keyboard'
import KeyboardEN from '@/components/KeyboardEN'
import KeyboardCN from '@/components/KeyboardCN'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/keyboard',
      name: 'keyboard',
      component: Keyboard
    },
    {
      path: '/KeyboardEN',
      name: 'KeyboardEN',
      component: KeyboardEN
    },
    {
      path: '/KeyboardCN',
      name: 'KeyboardCN',
      component: KeyboardCN
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js